// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workbook-body {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: left;
  align-items: center;
}

.header-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.header {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
}

.workbook-title {
  margin: 0px;
  font-size: 32px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
}

.mat-form-field {
  width: 100%;
}

:host ::ng-deep app-word-pairings .mat-form-field {
  border-width: 0 !important;
}

.workbook-owner {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: 0.4px;
  cursor: pointer;
}

.workbook-description {
  opacity: 0.48;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
}

h2 {
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  margin: 0;
}

.description {
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
}

.word-table {
  width: 100%;
  border-spacing: 0px;
}

.word-panel {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  margin: 1px;
}

.word-selected {
  background-color: #866dff !important;
  color: white !important;
}
.word-selected .word-content {
  color: white !important;
}

.word-panel > div {
  display: flex;
  align-items: center;
}

.word-drag-indicator {
  color: #ccc;
}

.word-counter {
  color: #ccc;
  margin-right: 10px;
}

.word-content {
  font-weight: bolder;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
}

.play-button {
  margin-left: 20px;
  color: #ccc;
}

.word-list-header {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 25px;
  position: sticky;
  top: 0;
  z-index: 1;
}

.words-container {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  padding-top: 20px;
}

.results-container::-webkit-scrollbar {
  display: none;
}

.filters-container {
  border-radius: 8px;
  display: flex;
  width: 75%;
  margin-left: 20px;
  margin-right: 20px;
}

.results-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
  border-radius: 8px;
  max-width: 25%;
  min-height: 200px;
  max-height: 600px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  height: calc(100% - 283px);
}

.divider {
  width: 100%;
  height: 1px;
}

.search-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 28px;
  border: solid 1px rgba(255, 255, 255, 0.25);
  opacity: 0.8;
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  padding: 5px;
}
.search-box input {
  background: transparent;
  border: none;
  outline: none;
}
.search-container {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  padding: 20px 24px;
}

:host ::ng-deep .button-container {
  display: flex;
  padding-top: 20px;
  flex-direction: row;
  padding-left: 20px;
  padding-bottom: 16px;
  background-color: white;
  position: fixed;
  bottom: 1px;
  width: 100%;
  border-top: solid 1px rgba(134, 109, 255, 0.48);
}
.dark-theme :host ::ng-deep .button-container {
  background-color: #18112f !important;
}

.words-button {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 5;
  padding-bottom: 5;
}

.no-results {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.selection-container {
  margin-top: 0px;
  margin-bottom: 10px;
  padding: 0px;
  display: flex;
  justify-content: center;
  box-shadow: none;
}
.selection-container mat-label {
  color: #866dff;
  font-size: 14px;
  font-weight: 500;
}

.selection-inner-content {
  width: 100%;
  padding: 0 24px;
}

.delete {
  color: red !important;
  display: flex;
  align-items: center;
  height: 36px;
}

.tab-label {
  font-weight: bold;
}

:host ::ng-deep .filters-container app-word-filter:first-child {
  background: blue;
}
:host ::ng-deep .filters-container app-word-filter:first-child > .filter {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
:host ::ng-deep .filters-container .selection-container {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.dark-theme :host ::ng-deep .filters-container app-word-filter > .filter {
  border-bottom: 1px solid rgba(241, 237, 248, 0.12) !important;
}
:host ::ng-deep .workbook-builder-tab .mat-mdc-tab-body.mat-mdc-tab-body-active {
  height: calc(100vh - 195px);
  overflow-y: hidden;
}

:host ::ng-deep .mat-mdc-radio-button .mdc-radio {
  padding: 0;
}
:host ::ng-deep .word-filter-adjust-container input {
  text-align: center;
}
:host ::ng-deep .word-filter-pairings-container .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
:host ::ng-deep .words-tab-container .filter-container .mdc-notched-outline__leading, :host ::ng-deep .words-tab-container .filter-container .mdc-notched-outline__notch, :host ::ng-deep .words-tab-container .filter-container .mdc-notched-outline__trailing {
  border: 0;
}
:host ::ng-deep .words-tab-container .filter-container .mat-mdc-select-placeholder {
  color: #866DFF;
  font-size: 16px;
  font-weight: 500;
}
:host ::ng-deep .words-tab-container .filter-container .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
:host ::ng-deep .add-save-setting .passage-field .mat-mdc-text-field-wrapper {
  padding-left: 5px;
  padding-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/core/components/workbooks/workbook-builder/workbook-builder.scss"],"names":[],"mappings":"AAKA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;AAJF;;AAOA;EACE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;AAJF;;AAOA;EACE,WAAA;AAJF;;AAOE;EACE,0BAAA;AAJJ;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EAEA,eAAA;AANF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AALF;;AAOA;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EAEA,SAAA;AALF;;AAQA;EACE,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AALF;;AASA;EACE,WAAA;EACA,mBAAA;AANF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EAEA,aAAA;EACA,WAAA;AANF;;AAQA;EAEE,oCAAA;EACA,uBAAA;AANF;AAOE;EACE,uBAAA;AALJ;;AAQA;EACE,aAAA;EACA,mBAAA;AALF;;AAOA;EACE,WAAA;AAJF;;AAMA;EACE,WAAA;EACA,kBAAA;AAHF;;AAKA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,WAAA;AAFF;;AAIA;EACE,2BAAA;EACA,4BAAA;EAGA,aAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAHF;;AAKA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAIA;EACE,kBAAA;EAEA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AAFF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,wBAAA;EACA,qBAAA;EACA,0BAAA;AADF;;AAIA;EACE,WAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;AADF;AAKE;EAEE,uBAAA;EACA,YAAA;EACA,aAAA;AAJJ;AAgBA;EACE,aAAA;EACA,2BAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AAdF;;AAiBE;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EAEA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,+CAAA;AAfJ;AAgBI;EACE,oCAAA;AAdN;;AAkBA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AAfF;;AAwBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AArBF;;AAuBA;EACE,eAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AApBF;AAqBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAnBJ;;AA+BA;EAEE,WAAA;EACA,eAAA;AA7BF;;AA+BA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AA5BF;;AA8BA;EACE,iBAAA;AA3BF;;AAiCI;EACE,gBAAA;AA9BN;AA+BM;EACE,2BAAA;EACA,4BAAA;AA7BR;AAgCI;EACI,8BAAA;EACA,+BAAA;AA9BR;AAkCQ;EACE,6DAAA;AAhCV;AAsCE;EACE,2BAAA;EACA,kBAAA;AApCJ;;AAyCE;EACE,UAAA;AAtCJ;AA0CI;EACE,kBAAA;AAxCN;AA6CI;EACE,aAAA;AA3CN;AAiDM;EACE,SAAA;AA/CR;AAiDM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA/CR;AAkDM;EACE,aAAA;AAhDR;AAuDM;EACE,iBAAA;EACA,kBAAA;AArDR","sourcesContent":["// @import \"../../../../../src/styles.scss\";\n// @import \"../../../../component_variable.scss\";\n::ng-deep .mat-tab-body{\n  // overflow-y: hidden !important;\n}\n.workbook-body{\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: left;\n  align-items: center;\n  // background-color: $primary-light;\n}\n.header-container{\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  // background-color: $primary-light;\n}\n.header{\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px;\n  // background-color: $primary-dark-background-color;\n}\n.workbook-title{\n  margin: 0px;\n  font-size: 32px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  // color: $primary-dark;\n}\n.mat-form-field{\n  width: 100%;\n}\n:host ::ng-deep {\n  app-word-pairings  .mat-form-field{\n    border-width: 0 !important;\n  }\n}\n\n.workbook-owner{\n  font-size: 14px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.14;\n  letter-spacing: 0.4px;\n  // color: $primary;\n  cursor: pointer;\n}\n.workbook-description{\n  opacity: 0.48;\n  font-family: Roboto;\n  font-size: 16px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.25;\n  letter-spacing: normal;\n}\nh2{\n  font-size: 20px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.25;\n  letter-spacing: normal;\n\n  margin: 0;\n\n}\n.description{\n  font-family: Roboto;\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.25;\n  letter-spacing: normal;\n\n  // margin: 5px;\n}\n.word-table {\n  width: 100%;\n  border-spacing: 0px;\n}\n.word-panel{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  // border-bottom: 1px solid #f1edf8;\n  padding: 10px;\n  margin: 1px;\n}\n.word-selected{\n  // background-color: rgba($primary, 0.15);\n  background-color: #866dff !important;\n  color: white !important;\n  .word-content {\n    color: white !important;\n  }\n}\n.word-panel > div {\n  display: flex;\n  align-items: center;\n}\n.word-drag-indicator {\n  color: #ccc;\n}\n.word-counter{\n  color: #ccc;\n  margin-right: 10px\n}\n.word-content{\n  font-weight: bolder;\n  font-size: 16px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  // color: $primary-dark;\n}\n.play-button{\n  margin-left: 20px;\n  color: #ccc;\n}\n.word-list-header{\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  // background-color: $primary-dark-background-color;\n  // color: $primary-dark;\n  padding: 25px;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n.words-container{\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  padding-top: 20px;\n  // background-color: $primary-light;\n}\n.results-container::-webkit-scrollbar {\n  display: none;\n}\n.filters-container{\n  border-radius: 8px;\n  // background-color: white;\n  display: flex;\n  width: 75%;\n  margin-left: 20px;\n  margin-right: 20px;\n}\n.results-container{\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  overflow: auto;\n  border-radius: 8px;\n  max-width: 25%;\n  min-height: 200px;\n  max-height: 600px;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  height: calc(100% - 283px);\n  // background-color: $primary-dark-background-color;\n}\n.divider{\n  width: 100%;\n  height: 1px;\n  // border: solid 1px $whizzimo-border-transparent;\n}\n.search-box{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  border-radius: 28px;\n  border: solid 1px rgba(255, 255, 255, 0.25);\n  opacity: 0.8;\n  font-family: Roboto;\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  padding: 5px;\n  span{\n    // color: rgba($whizzimo-black-white,0.87);\n  }\n  input{\n    // color: rgba($whizzimo-black-white,0.87);\n    background: transparent;\n    border: none;\n    outline: none;\n    &::placeholder{\n      // color: rgba($whizzimo-black-white,0.87);\n    }\n    &::-moz-placeholder{\n      // color: rgba($whizzimo-black-white,0.87);\n    }\n    &::-webkit-input-placeholder{\n      // color: rgba($whizzimo-black-white,0.87);\n    }\n  }\n}\n.search-container{\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  padding: 20px 24px;\n}\n:host ::ng-deep {\n  .button-container{\n    display: flex;\n    padding-top: 20px;\n    flex-direction: row;\n    padding-left: 20px;\n    padding-bottom: 16px;\n    // background-color: $primary-dark-background-color;\n    background-color: white;\n    position: fixed;\n    bottom: 1px;\n    width: 100%;\n    border-top: solid 1px rgba(134, 109, 255, 0.48);\n    .dark-theme & {\n      background-color: #18112f !important;\n    }\n  }\n}\n.words-button{\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-top: 5;\n  padding-bottom: 5;\n}\n.find-words-button{\n  // background-color: $primary;\n  // color: white !important;\n}\n.save-and-close-button{\n  // color: $primary;\n}\n.no-results{\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n}\n.selection-container{\n  margin-top: 0px;\n  margin-bottom: 10px;\n  padding: 0px;\n  display: flex;\n  justify-content: center;\n  box-shadow: none;\n  mat-label {\n    color: #866dff;\n    font-size: 14px;\n    font-weight: 500;\n  }\n  // border-radius: 4px;\n}\n.selection-container-active{\n  // color: $primary-dark;\n  // border: solid 1px $transparent-33;\n}\n.selection-container-inactive{\n  // color: $primary-dark;\n  // border: solid 1px $transparent-33;\n}\n.selection-inner-content{\n  // width: 90%;\n  width: 100%;\n  padding: 0 24px;\n}\n.delete{\n  color: red !important;\n  display: flex;\n  align-items: center;\n  height: 36px;\n}\n.tab-label{\n  font-weight: bold;\n  // color: $primary-dark;\n}\n\n:host ::ng-deep {\n  .filters-container {\n    app-word-filter:first-child {\n      background: blue;\n      > .filter {\n        border-top-left-radius: 8px;\n        border-top-right-radius: 8px;\n      }\n    }\n    .selection-container {\n        border-bottom-left-radius: 8px;\n        border-bottom-right-radius: 8px;\n    }\n    .dark-theme & {\n      app-word-filter {\n        > .filter {\n          border-bottom: 1px solid rgba(241, 237, 248, 0.12) !important;\n        }\n      }\n    }\n  }\n\n  .workbook-builder-tab .mat-mdc-tab-body.mat-mdc-tab-body-active {\n    height: calc(100vh - 195px);\n    overflow-y: hidden;\n  }\n}\n\n:host ::ng-deep {\n  .mat-mdc-radio-button .mdc-radio {\n    padding: 0;\n  }\n\n  .word-filter-adjust-container {\n    input {\n      text-align: center;\n    }\n  }\n\n  .word-filter-pairings-container {\n    .mat-mdc-form-field-subscript-wrapper {\n      display: none;\n    }\n  }\n\n  .words-tab-container {\n    .filter-container {\n      .mdc-notched-outline__leading, .mdc-notched-outline__notch, .mdc-notched-outline__trailing {\n        border: 0;\n      }\n      .mat-mdc-select-placeholder {\n        color: #866DFF;\n        font-size: 16px;\n        font-weight: 500;\n      }\n\n      .mat-mdc-form-field-subscript-wrapper {\n        display: none;\n      }\n    }\n  }\n\n  .add-save-setting {\n    .passage-field {\n      .mat-mdc-text-field-wrapper {\n        padding-left: 5px;\n        padding-right: 5px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
